import type { Await } from '#src/types/index.ts';

import {
  NAME as BANK_APPROVAL_ERROR,
  BankApprovalError,
} from './bankApproval.ts';
import {
  NAME as MIGRATOR_APPROVAL_ERROR,
  MigratorApprovalError,
} from './migratorApproval.ts';
import { NAME as MUTATION_ERROR, MutationError } from './mutation.ts';
import { NAME as NETWORK_ERROR, NetworkError } from './network.ts';
import {
  NAME as WALLET_ACCESS_ERROR,
  WalletAccessError,
} from './walletAccess.ts';

const errors = [
  BANK_APPROVAL_ERROR,
  MIGRATOR_APPROVAL_ERROR,
  MUTATION_ERROR,
  NETWORK_ERROR,
  WALLET_ACCESS_ERROR,
] as const;

export type AppError = (typeof errors)[number];

function isAppError(errorName: string): errorName is AppError {
  return errors.includes(errorName as any);
}

export function errorWrapper<T extends (...args: any[]) => any>(
  fn: T,
  rescueFrom?: AppError[]
): (...args: Parameters<T>) => Promise<{
  error?: { name: AppError; message: string };
  result?: Await<ReturnType<T>>;
}> {
  return async (...args: Parameters<T>) => {
    try {
      const result = await fn(...args);
      return { result };
    } catch (error: any) {
      const { name, message } = error;
      if (isAppError(name) && (rescueFrom || errors).includes(name))
        return { error: { name, message } };

      throw error;
    }
  };
}

export {
  BankApprovalError,
  MigratorApprovalError,
  MutationError,
  NetworkError,
  WalletAccessError,
};
